class GASv3 {
  track() {
    return Promise.reject('Not yet implemented.');
  }
}

export { GASv3 };

export default new GASv3();
